/**
 * Compact USD for charts and tables: $1,234k / $5M style (matches dashboard graphs).
 */
export function formatAsCurrency(value) {
  let roundedValue;
  let suffix;

  if (Math.abs(value) >= 1000000) {
    roundedValue = Math.round(value / 1000000);
    suffix = "M";
  } else if (Math.abs(value) >= 1000) {
    roundedValue = Math.round(value / 1000);
    suffix = "k";
  } else {
    roundedValue = Math.round(value);
    suffix = "";
  }

  const absValue = Math.abs(roundedValue)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return value < 0 ? `-$${absValue}${suffix}` : `$${absValue}${suffix}`;
}
